<template>
    <static-report-cover
        title="Watershed Summary"
        :name-subtitle="watershedName"
        :id-subtitle="`Watershed Number: ${wfi}`"
    >
        <mapbox-gl-map
            id="map"
            :options="getMapOptions()"
            @load="initialize"
        />
    </static-report-cover>
</template>

<script>
import MapboxGlMap from '@foundryspatial/mapbox-gl-map';
import mapboxgl from 'mapbox-gl';

import scssVars from '@/assets/scss/_variables.scss';
import StaticReportCover from '@/components/Report/StaticReportCover.vue';

export default {
    name: 'ReportCover',

    components: {
        MapboxGlMap,
        StaticReportCover,
    },

    props: {
        reportData: {
            type: Object,
            required: true,
        },
    },

    computed: {
        watershedName() {
            return this.$route.query.watershedName;
        },

        wfi() {
            return this.$route.query.wfi;
        },
    },

    methods: {
        /**
         * Builds and returns a mapbox gl map config object
         *
         * @returns {object} - Mapbox GL map options
         */
        getMapOptions() {
            return {
                style: process.env.VUE_APP_MAPBOX_DEFAULT_STYLE,
                center: this.lngLat,
                zoom: 5,
                interactive: false,
                // enable canvas png export (for pdfs)
                preserveDrawingBuffer: true,
            };
        },

        /**
         * Initialize the map element
         *
         * @param {Event} ev - the event received from the map when it's initialized
         * @param {mapboxgl.Map} map - Mapbox GL map object
         */
        initialize(ev, map) {
            // emit event when map is loaded and idle
            map.on('idle', () => this.$emit('load'));

            this.setView(map);
            this.addLayers(map);
        },

        /**
         * Position the given map
         *
         * @param {mapboxgl.Map} map - Mapbox GL map object
         */
        setView(map) {
            // fit to bounding box of the watershed polygon
            const bounds = new mapboxgl.LngLatBounds();
            this.reportData.overview.query_polygon.coordinates[0].forEach((coord) => {
                bounds.extend(coord);
            });

            map.fitBounds(bounds, {
                padding: 50,
                animate: false,
            });
        },

        /**
         * Add watershed polygon
         *
         * @param {mapboxgl.Map} map - Mapbox GL map object
         */
        addLayers(map) {
            map.addLayer({
                id: 'watershed-polygon',
                type: 'fill',
                source: {
                    type: 'geojson',
                    data: this.reportData.overview.query_polygon,
                },
                layout: {},
                paint: {
                    'fill-color': scssVars.colorWatershedQuery,
                    'fill-opacity': 0.5,
                    'fill-outline-color': scssVars.colorWatershedQueryBorder,
                },
            });
        },
    },
};
</script>
